import React, { useRef } from "react";
import KvFlower from "../images/kv_flower.webp";
import KvFlowerLeftMb from "../images/kv_flower_left_mb.webp";
import KvFlowerRightMb from "../images/kv_flower_right_mb.webp";
import KvTemple from "../images/kv_temple_s.webp";
import KvSun from "../images/kv_sun_s.webp";
import { Tween, Timeline } from "react-gsap";

const Kv = (props) => {
    const { progress } = props;
    const screenWidth = useRef(window.innerWidth).current;

    return (
        <section
            className="kv"
            data-aos="fade-in"
            data-aos-easing="linear"
            data-aos-duration="1000"
        >
            {
                screenWidth <= 768 ?
                    <>
                        <h1 className="title">2023潮Way台南最有台南味</h1>
                        <img className="flower left" src={KvFlowerLeftMb} width={375} height={617} alt="kv-flower-mb" />
                        <img className="flower right" src={KvFlowerRightMb} width={375} height={617} alt="kv-flower-mb" />
                    </>
                    :
                    <Timeline totalProgress={progress} paused>
                        <h1 className="title">2023潮Way台南最有台南味</h1>
                        <Tween
                            from={{ y: "70vh", opacity: "0.2" }}
                            to={{ y: "0", opacity: "1" }}
                        >
                            <img className="flower" src={KvFlower} width={1920} height={894} alt="kv-flower" />
                        </Tween>
                        <Tween></Tween>
                        <img className="temple" src={KvTemple} width={1920} height={992} alt="kv-temple" />
                        <img className="sun" src={KvSun} width={816} height={818} alt="kv-sun" />
                    </Timeline>

            }
        </section>
    );
};

export default Kv;
